module.exports = __webpack_public_path__ + "media/images/help/dog_profile_form-5fb7f59e8bd694b8ce11d436b65b7fcf.png";